module.exports = __webpack_public_path__ + "img/20190801162849545.5ce64a50.png";